import React from 'react';

/**
 * APEX Logo — Le composant officiel de la marque.
 *
 * Forme : A en chevron pur (sans barre horizontale)
 * Outline : 14px épais, dégradé cyan→fuchsia diagonal
 * Intérieur : triangle plein avec dégradé fuchsia (dense en haut, fade en bas)
 *
 * Props:
 *   - size  : hauteur en px (défaut 32). La largeur s'adapte.
 *   - className : classes Tailwind additionnelles
 */
export default function ApexLogo({ size = 32, className = '' }) {
  const ratio = 110 / 135;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-5 -5 130 110"
      width={size}
      height={size * ratio}
      className={className}
      aria-label="APEX logo"
    >
      <defs>
        <linearGradient id="apex-logo-outline" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="100%" stopColor="#e879f9" />
        </linearGradient>
        <linearGradient id="apex-logo-inner" x1="50%" y1="100%" x2="50%" y2="0%">
          <stop offset="0%" stopColor="#e879f9" stopOpacity="0.05" />
          <stop offset="100%" stopColor="#e879f9" stopOpacity="0.6" />
        </linearGradient>
      </defs>
      <polygon points="60,30 30,100 90,100" fill="url(#apex-logo-inner)" />
      <polygon
        points="60,0 0,100 30,100 60,30 90,100 120,100"
        fill="none"
        stroke="url(#apex-logo-outline)"
        strokeWidth="14"
        strokeLinejoin="miter"
      />
    </svg>
  );
}
